
import * as vClickOutside from "v-click-outside";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      menuOpen: false,
      mobileView: true,
      searchOpen: false,
      activeNavElement: null,
      shownActiveElement: null,
      activeNavMobileElement: null,

      options: [
        {
          name: "icon",
          label: this.$t("label.icon"),
          type: "image",
          size: "16x16",
        },
        {
          name: "description",
          label: this.$t("label.description"),
          type: "tipTap",
        },
      ],
      optionsSocial: [
        {
          name: "icon",
          label: this.$t("label.icon"),
          type: "image",
          size: "20x20",
        },
        {
          name: "link",
          label: this.$t("label.link"),
          type: "link",
        },
      ],
    };
  },

  watch: {
    $route() {
      this.closeMenu();
      this.closeSearch();
      this.closeActiveElement();
    },
  },

  mounted() {
    window.addEventListener("resize", this.checkIfMobileView, {
      passive: true,
    });

    this.checkIfMobileView();
  },

  methods: {
    setActiveElement(el) {
      this.activeNavElement = el;
    },
    showActiveElement(el) {
      this.shownActiveElement = el;
    },

    checkIfMobileView() {
      if (window.innerWidth > 1379) {
        this.mobileView = false;
      } else this.mobileView = true;
    },

    toggleMenu(e) {
      const el = e.currentTarget;

      if (el) {
        el.classList.toggle("menuOpen");

        this.menuOpen = el.classList.contains("menuOpen");
      }

      const element = document.documentElement;
      if (element) {
        if (this.menuOpen) {
          element.classList.add("overflow-hidden");
        } else {
          element.classList.remove("overflow-hidden");
        }
      }
    },
    closeMenu() {
      setTimeout(() => {
        this.menuOpen = false;
        const openClass = document.getElementsByClassName("menuOpen");
        if (openClass && openClass[0]) {
          openClass[0].classList.remove("menuOpen");
        }

        const element = document.documentElement;
        if (element) {
          element.classList.remove("overflow-hidden");
        }
      }, 50);
    },

    openSearch() {
      this.searchOpen = true;

      if (document.getElementById("searchInput")) {
        setTimeout(() => {
          document.getElementById("searchInput").focus();
        }, 300);
      }
    },

    closeSearch() {
      this.searchOpen = false;
    },

    closeActiveElement() {
      this.activeNavElement = null;
      this.shownActiveElement = null;
    },

    setActiveMobileElement(el) {
      if (this.activeNavMobileElement === el) {
        this.activeNavMobileElement = null;
      } else this.activeNavMobileElement = el;
    },
  },
};
